export default __webpack_public_path__ + "static/media/39.e60bc067.png";